export default "__VITE_ASSET__69c0bcf0__"